import React, { Component } from "react";
import { profile, branch, alert, total, float, toFixed, format_date, random_charactor, GET, POST, PUT, DELETE, loading, Status, params, required, DatePicker, Select, BtnIcon, Swal, Pagination, Switch, Navbar, Modal, Resizer } from "../../../components/CustomComponent.js";
export default class Categories extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      modal_update: false,

      filter_search: "",
      filter_warehouse_id: "",

      data: [],
      count: 10,
      data_warehouse: [],

      id: "",
      uid: "",
      name: "",
      warehouse_id: "",
      category_code: "",
      description: ""
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }
  Get = async (page) => {
    let data, data_warehouse, count;
    loading(true);
    let [result, result_warehouse] = await Promise.all([GET("admin/setting/categories/list", { page: page, data_search: this.state.filter_search, warehouse_id: this.state.filter_warehouse_id }), GET("admin/setting/warehouses/list", { page: 0, data_search: "" })]);
    if (result?.status) {
      data = result.data;
      count = result.count;
    }
    if (result_warehouse?.status) {
      data_warehouse = result_warehouse.data.map((e) => ({ value: e.uid, label: e.name, id: e.id }));
    }
    this.setState({
      data,
      data_warehouse,
      count
    });
    loading(false);
  };
  CreateUpdate = async () => {
    const { uid, name, category_code, description, warehouse_id } = this.state;
    if (!name.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกชื่อหมวดหมู่");
      return;
    } else if (!category_code.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกรหัสหมวดหมู่");
      return;
    } else if (!warehouse_id) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกคลังสินค้า");
      return;
    }

    loading(true);
    let body = {
      name,
      category_code,
      description,
      warehouse_id
    };

    let result = !uid ? await POST("admin/setting/categories/create", body) : await PUT("admin/setting/categories/update/" + uid, body);
    if (result?.status) {
      alert("#", "success");
    } else {
      alert("", "warning", "แจ้งเตือน", result?.message || "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง");
    }
    loading(false);
  };
  Delete = async (id) => {
    if (await alert("", "warning", "ลบข้อมูล", "ยืนยันการลบรายการนี้หรือไม่ ?", "ลบข้อมูล", "ยกเลิก")) {
      loading(true);
      let result = await DELETE("admin/setting/categories/delete/" + id, null);
      if (result?.status) {
        alert("#", "success");
      }
      loading(false);
    }
  };
  render() {
    const { modal_create, modal_update, filter_search, filter_warehouse_id, data, count,data_warehouse, id, uid, name, category_code,warehouse_id, description } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="body p-3">
          <div className="rounded-4 bg-white p-3">
            <div className="d-flex justify-content-between">
              <h4 className="fw-bold mb-3 me-3">หมวดหมู่สินค้า</h4>
              <button
                className="btn btn-dark px-3 ms-auto mb-2 categories.create"
                onClick={async () => {
                  this.setState({ id: "", uid: "", name: "", category_code: "", warehouse_id: "", description: "", modal_create: true });
                }}
              >
                เพิ่มรายการ
              </button>
            </div>
            <div className="d-flex flex-wrap">
              <input
                type="text"
                className="form-control wpx-200 me-2 mb-2"
                placeholder="ค้นหา..."
                onChange={(e) => {
                  this.setState({ filter_search: e.target.value });
                }}
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    this.Get(1);
                  }
                }}
                value={filter_search}
              />

              <Select
                className="form-control wpx-200 me-2 mb-2"
                placeholder="คลังสินค้า..."
                options={data_warehouse}
                onChange={(e) => {
                  this.setState({ filter_warehouse_id: e });
                }}
                value={filter_warehouse_id}
              />
              <div className="d-flex">
                <button
                  className="btn btn-dark px-3 me-2 mb-2"
                  onClick={() => {
                    this.Get(1);
                  }}
                >
                  ค้นหา
                </button>
                <button
                  className="btn btn-outline-dark px-3 me-2 mb-2"
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  ล้างค่า
                </button>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table rounded-3 overflow-hidden table-hover">
                <thead>
                  <tr>
                    <td className="text-nowrap">ลำดับ</td>
                    <td className="text-nowrap">รหัสหมวดหมู่</td>
                    <td className="text-nowrap">ชื่อหมวดหมู่</td>
                    <td className="text-nowrap">คลังสินค้า</td>
                    <td className="text-nowrap">รายละเอียด</td>
                    <td></td>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr>
                      <td className="text-nowrap">{index + 1}</td>
                      <td className="text-nowrap">{item.category_code || "-"}</td>
                      <td className="text-nowrap">{item.name || "-"}</td>
                      <td className="text-nowrap">{item.warehouse?.name || ""}</td>
                      <td className="text-nowrap">{item.description || "-"}</td>
                      <td className="text-center align-middle wpx-100">
                        <div className="d-flex">
                          <BtnIcon
                            className="categories.update"
                            type="update"
                            onClick={() => {
                              this.setState({ ...item, warehouse_id: item.warehouse?.uid|| "", modal_update: true });
                            }}
                          />
                          <BtnIcon
                            className="categories.delete"
                            type="delete"
                            onClick={() => {
                              this.Delete(item.uid);
                            }}
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-2">
            <Pagination className="mb-3" count={Math.ceil(count / 10) || 1} showFirstButton showLastButton onChange={(_, page) => this.Get(page)} />
          </div>
        </div>
        {/* CREATE UPDATE */}
        <Modal show={modal_create || modal_update} onHide={() => this.setState({ modal_create: false, modal_update: false })}>
          <Modal.Header className="border-0" closeButton>
            <h5 className="fw-bold mb-0">{modal_create ? "เพิ่ม" : modal_update ? "แก้ไข" : ""}หมวดหมู่สินค้า</h5>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">รหัสหมวดหมู่{required}</div>
              <input
                type="text"
                className="form-control"
                placeholder="รหัสหมวดหมู่..."
                onChange={(e) => {
                  this.setState({ category_code: e.target.value });
                }}
                value={category_code}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">ชื่อหมวดหมู่{required}</div>
               <input
                type="text"
                className="form-control"
                placeholder="ชื่อหมวดหมู่..."
                onChange={(e) => {
                  this.setState({ name: e.target.value });
                }}
                value={name}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">รายละเอียด</div>
              <textarea
                className="form-control"
                placeholder="รายละเอียด..."
                rows={5}
                onChange={(e) => {
                  this.setState({ description: e.target.value });
                }}
                value={description}
              />
            </div><div className="d-flex mb-3">
              <div className="wpx-150 mt-2">คลังสินค้า{required}</div>
              <Select
                className="form-control"
                placeholder="คลังสินค้า..."
                options={data_warehouse}
                onChange={(e) => {
                  this.setState({ warehouse_id: e });
                }}
                value={warehouse_id}
              />
            </div>
          </Modal.Body>
          <Modal.Footer className="pt-0 border-0 d-flex justify-content-end">
            <div className="d-flex">
              <button
                className="btn btn-dark px-5 me-1"
                onClick={() => {
                  this.CreateUpdate();
                }}
              >
              บันทึก
              </button>
              <button
                className="btn btn-outline-dark px-5 ms-1"
                onClick={() => {
                  this.setState({ modal_create: false, modal_update: false });
                }}
              >
                ยกเลิก
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
